import React from 'react';
import { Text as PDFText } from '@react-pdf/renderer';

// styled-system v5 default space scale
const SPACE = [0, 4, 8, 16, 32, 64, 128, 256, 512];
const sp = (v: any): any =>
  typeof v === 'number' && Number.isInteger(v) && v >= 0 && v < SPACE.length
    ? SPACE[v]
    : v;

interface TextProps {
  style?: any;
  children?: React.ReactNode;
  fontSize?: any;
  color?: any;
  fontWeight?: any;
  textAlign?: any;
  m?: any;
  mt?: any;
  mb?: any;
  ml?: any;
  mr?: any;
  p?: any;
  pt?: any;
  pb?: any;
  pl?: any;
  pr?: any;
  [key: string]: any;
}

const Text = ({
  style,
  children,
  fontSize,
  color,
  fontWeight,
  textAlign,
  m,
  mt,
  mb,
  ml,
  mr,
  p,
  pt,
  pb,
  pl,
  pr,
  ...rest
}: TextProps) => {
  const computed: Record<string, any> = {};
  if (fontSize !== undefined) computed.fontSize = fontSize;
  if (color !== undefined) computed.color = color;
  if (fontWeight !== undefined) computed.fontWeight = fontWeight;
  if (textAlign !== undefined) computed.textAlign = textAlign;
  if (m !== undefined) computed.margin = sp(m);
  if (mt !== undefined) computed.marginTop = sp(mt);
  if (mb !== undefined) computed.marginBottom = sp(mb);
  if (ml !== undefined) computed.marginLeft = sp(ml);
  if (mr !== undefined) computed.marginRight = sp(mr);
  if (p !== undefined) computed.padding = sp(p);
  if (pt !== undefined) computed.paddingTop = sp(pt);
  if (pb !== undefined) computed.paddingBottom = sp(pb);
  if (pl !== undefined) computed.paddingLeft = sp(pl);
  if (pr !== undefined) computed.paddingRight = sp(pr);

  return (
    <PDFText style={[computed, style]} {...rest}>
      {children}
    </PDFText>
  );
};

export default Text;
